import { compareFileNames } from '@tanko/shared'

/** 作品清單的排序方式。加入時間新到舊是預設，與加入排序控制項之前的順序一致。 */
export const comicSortOrders = ['added-desc', 'added-asc', 'title-asc', 'title-desc'] as const

export type ComicSortOrder = typeof comicSortOrders[number]

export const DEFAULT_COMIC_SORT: ComicSortOrder = 'added-desc'

export function isComicSortOrder(value: unknown): value is ComicSortOrder {
  return typeof value === 'string' && (comicSortOrders as readonly string[]).includes(value)
}

/** 排序只需要標題與加入時間，因此不綁 Comic 全型別，測試也不必湊出整筆作品。 */
type Sortable = { title: string; addedAt: number }

/**
 * 依指定順序排序作品，回傳新陣列，不改動輸入。
 *
 * 標題比較用 packages/shared 的 compareFileNames，因此「第 2 卷」排在「第 10 卷」
 * 之前。標題相同時一律以 addedAt 遞增決勝：Array.prototype.sort 的穩定性雖有保證，
 * 但輸入順序本身會因為 liveQuery 重讀而變動，所以不依賴它。
 */
export function sortComics<T extends Sortable>(comics: readonly T[], order: ComicSortOrder): T[] {
  return [...comics].sort((a, b) => {
    if (order === 'added-desc') return b.addedAt - a.addedAt || compareFileNames(a.title, b.title)
    if (order === 'added-asc') return a.addedAt - b.addedAt || compareFileNames(a.title, b.title)
    const byTitle = compareFileNames(a.title, b.title)
    if (byTitle !== 0) return order === 'title-asc' ? byTitle : -byTitle
    return a.addedAt - b.addedAt
  })
}
